@if (!sharedSvc.isMobileMode() && mode!='center' && !unCommerceApp) {
  <div class="component-container desktop-mode">
    <div class="quantity-box" [ngClass]="mode">
      <input class="quantity" type="number"
        [id]="quantityId"
        [attr.aria-label]="'Quantity'|translate"
        [(ngModel)]="quantity"
        #qtyMdl="ngModel" [disabled]="disabled"
        >
      <div class="sep" aria-hidden="true"></div>
      <div class="quantity-buttons d-flex flex-column justify-content-around" style="gap: 1px; background: #ccc">
        <button (click)="qtyUp()" [attr.aria-controls]="quantityId" aria-label="+" [disabled]="qtyMdl.value == maxQty">
          <i class="fa fa-angle-up"></i>
        </button>
        <button (click)="qtyDown()" [attr.aria-controls]="quantityId" aria-label="-" [disabled]="qtyMdl.value == minQty">
          <i class="fa fa-angle-down"></i>
        </button>
      </div>
    </div>
  </div>
} @else {
  @if (!unCommerceApp) {
    <div class="component-container mobile-mode center h-100">
      <span class="label align-bottom">
        <label [for]="quantityId" translate>QTY</label>:
      </span>
      <div class="quantity-box d-inline-flex align-items-center rounded-pill text-center w-100 row-cols-3">
        <button class="quantity-buttons qadd" (click)="qtyUp()" [disabled]="qtyMdl.value == maxQty">+</button>
        <input class="quantity border-0 h-100" type="number"
          [id]="quantityId"
          [(ngModel)]="quantity"
          #qtyMdl="ngModel"
          [disabled]="disabled"
          >
        <button class="quantity-buttons qsub" (click)="qtyDown()" [disabled]="qtyMdl.value == minQty">-</button>
      </div>
    </div>
  }
}

